// src/api/axiosInstance.ts
import axios from "axios";
import { RootState, store } from "../store";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Attach interceptors
axiosInstance.interceptors.request.use((config) => {
  const state: RootState = store.getState();
  const token = state.Auth?.token_details?.accessToken
    ? state.Auth?.token_details?.accessToken
    : localStorage.getItem("tobacco_access_token");

  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// THIS is the important part
const createApiCall = () => axiosInstance;

export default createApiCall;
